import * as React from 'react';
import { IMenuProps } from './menu-props.interface';
import styled from 'styled-components';
import { MenuArrowRightIcon, MenuCloseIcon, MenuIcon, MenuArrowLeftIcon } from '../../icons';
import { HEADER_VIEW_HEIGHT } from './consts';
import { MenuIconContainer, MobileRouteWrapper } from './atoms';
import { action, observable } from 'mobx';
import { LinkOriginEnum } from '../../../enum/link-origin.enum';
import { getLinkFinalURL } from '../../../util/url/get-link-final-url';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { IMainMenuItem } from '../../../interface/main-menu-item.interface';
import { Ellipsis } from '../../ellipsis';

const MenuWrapper = styled.div`
  display: flex;
  width: 60px;
  flex: 0 0 60px;
`;

const MobileMenuItemsWrapper = styled.div`
  position: fixed;
  top: ${HEADER_VIEW_HEIGHT}px;
  left: 0;
`;

interface IMobileMenuItemsProps extends IMenuProps {
  onCloseMenu: () => void;
}

@inject('state')
@observer
class MobileMenuItems extends React.Component<IMobileMenuItemsProps & IInjectedProps> {
  parents: IMainMenuItem[] = [];
  @observable activeItem: IMainMenuItem;

  openSubMenu = (item: IMainMenuItem) => action((e: any) => {
    this.parents.push(this.activeItem);
    this.activeItem = item;
    e.preventDefault();
    e.stopPropagation();
  })

  @action
  closeSubMenu = (e) => {
    this.activeItem = this.parents.pop();
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    let items = this.props.items;
    if (this.activeItem) {
      items = this.activeItem.subItems;
    }
    return <MobileMenuItemsWrapper>
      {this.activeItem && <MobileRouteWrapper
        key={this.activeItem.id}
        color={this.props.textColor}
        backgroundColor={this.props.backgroundColor}
        opacity={this.props.backgroundOpacity}
        hoverColor={this.props.hoverTextColor}
        isSelected={true}
        onClick={this.closeSubMenu}
        to={undefined}
      >
        <MenuArrowLeftIcon style={{marginLeft: 5}} />
        <Ellipsis style={{display: 'block', flex: '1 1 100%', textAlign: 'left'}}>
          {this.activeItem.label}
        </Ellipsis>
      </MobileRouteWrapper>}
      {items.map((item) => (
        <MobileRouteWrapper
          key={item.id}
          color={this.props.textColor}
          backgroundColor={this.props.backgroundColor}
          opacity={this.props.backgroundOpacity}
          hoverColor={this.props.hoverTextColor}
          isSelected={this.props.state.activeDesign.data && item.link && item.link.origin === LinkOriginEnum.Internal && item.link.pageId === this.props.state.activeDesign.page.id}
          onClick={item.subItems && item.subItems.length > 0 ? this.openSubMenu(item) : this.props.onCloseMenu}
          to={item.subItems && item.subItems.length > 0 ? undefined : getLinkFinalURL(this.props.state, item.link)}
        >
          <Ellipsis style={{display: 'block', flex: '1 1 100%', textAlign: 'left'}}>
            {item.label}
          </Ellipsis>
          {item.subItems && item.subItems.length > 0 && <MenuArrowRightIcon />}
        </MobileRouteWrapper>
      ))}
    </MobileMenuItemsWrapper>;
  }
}

@observer
export class MobileMenu extends React.Component<IMenuProps> {
  @observable menuContentShown: boolean = false;

  @action
  toggleMenu = () => {
    this.menuContentShown = !this.menuContentShown;
  }

  render() {
    return <MenuWrapper>
      <MenuIconContainer
        onClick={this.props.inEditor ? undefined : this.toggleMenu}
        opacity={this.props.backgroundOpacity}
        color={this.menuContentShown ? this.props.hoverTextColor : this.props.textColor}
        hoverColor={this.props.hoverTextColor}
        isSelected={this.menuContentShown}
        backgroundColor={this.props.backgroundColor}
      >
        {this.menuContentShown ? <MenuCloseIcon /> : <MenuIcon />}
        {this.menuContentShown && <MobileMenuItems {...this.props} onCloseMenu={this.toggleMenu}/>}
      </MenuIconContainer>
    </MenuWrapper>;
  }
}